import { mapMutations, mapState, ELECTRONICBANK } from '@/store/modules/electronicBank'
import {
  mapMutations as mapMutationsApplyBank,
  mapState as mapStateApplyBank,
  APPLY,
} from '@/store/modules/applybank'
import { cloneDeep } from 'lodash'

// 区分数据来源，以渲染不同的银行保函数据
export default {
  created() {
    const isAhGzElectronicBank = this.$route.path.includes('anhui') || this.$route.path.includes('guizhouBank')
    let m, t, s
    if (isAhGzElectronicBank) {
      m = mapMutations
      t = ELECTRONICBANK
      s = mapState
    } else {
      m = mapMutationsApplyBank
      t = APPLY
      s = mapStateApplyBank
    }
    const { guarantee, clear, setDdit } = m({
      guarantee: t.GUARANTEE,
      clear: t.CLEAR,
      setDdit: t.SET_EDIT_ID,
    })
    const states = s(['guarantee', 'edit'])
    const state = states.guarantee.call(this)
    const edit = states.edit.call(this)

    this.state = state
    this.edit = edit
    this.guarantee = guarantee
    this.clear = clear
    this.setDdit = setDdit
  },
  methods: {
    init(v) {
      if (v) {
        this.form = cloneDeep(v)
        if (this.initViewData && typeof this.initViewData === 'function') {
          this.initViewData()
        }
      }
    },
  },
}
